<template>
  <div
    :id="source"
    :class="['flex flex-col items-center', padding, alignment]"
    :style="{ gap: `${componentGap}px` }"
  >
    <ThemeImage :class="css" :icon="computedIcon" alt="empty_screen" />

    <div class="flex flex-col items-center" :style="{ gap: `${textGap}px` }">
      <span
        :class="[
          'text_color font-normal proxima_nova',
          description ? 'font-semibold' : 'opacity-60',
        ]"
        :style="{ fontSize: `${textSize}px` }"
      >
        {{ text }}
      </span>

      <span
        v-if="description"
        class="secondary_color text-center max-w-md"
        :style="{ fontSize: `${descriptionSize}px` }"
      >
        {{ description }}
      </span>
    </div>

    <slot></slot>
  </div>
</template>

<script setup>
import { imageNames } from "@/src/constants/imageConstants";
import { emptyScreenTypes } from "@/src/constants/searchConstants.js";
import { computed } from "vue";

const props = defineProps({
  source: { type: String, required: true },
  text: { type: String, default: "No results found!" },
  textSize: { type: Number, default: 16 },
  description: { type: String, default: "" },
  descriptionSize: { type: Number, default: 14 },
  css: { type: String, default: "size-[72px]" },
  type: { type: String, default: emptyScreenTypes.DEFAULT },
  padding: { type: String, default: "my-12" },
  alignment: { type: String, default: "" },
  textGap: { type: Number, default: 4 },
  componentGap: { type: Number, default: 8 },
  customIcon: { type: String, default: null },
});

const computedIcon = computed(() => {
  if (props.customIcon) {
    return props.customIcon;
  }

  switch (props.type) {
    case emptyScreenTypes.SEARCH:
      return imageNames.SEARCH_EMPTY_SCREEN_GREY;
    case emptyScreenTypes.CHART_AND_TABLE:
      return imageNames.CHART_AND_TABLE_EMPTY_SCREEN_GREY;
    case emptyScreenTypes.CALL_LOGS:
      return imageNames.CALL_LOGS_EMPTY_SCREEN_GREY;
    case emptyScreenTypes.CALL_QUALITY:
      return imageNames.CALL_QUALITY_EMPTY_SCREEN_GREY;
    case emptyScreenTypes.CALL_CAMPAIGNS:
      return imageNames.CALL_CAMPAIGNS_EMPTY_SCREEN;
    case emptyScreenTypes.SECONDARY:
      return imageNames.EMPTY_STATE_SECONDARY;
    case emptyScreenTypes.PROSPECT:
      return imageNames.PROSPECT_EMPTY_SCREEN;
    case emptyScreenTypes.DEFAULT:
    default:
      return imageNames.EMPTY_SCREEN_GREY;
  }
});
</script>
